import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
    static values = {
        title: String,
        icon: { type: String, default: "success" },
        timer: { type: Number, default: 5000 },
        position: { type: String, default: "center" },
        resetForm: { type: Boolean, default: true } // 👈 allow disabling if needed
    }

    connect() {
        Swal.fire({
            toast: true,
            title: this.titleValue || "",
            icon: this.iconValue || "success",
            position: this.positionValue || "bottom-end",
            timer: this.timerValue || 6000,
            showConfirmButton: false,
            timerProgressBar: true,
            customClass: {
                popup: "swal2-ea-popup",
                title: "swal2-ea-title"
            },
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer)
                toast.addEventListener("mouseleave", Swal.resumeTimer)
            },
            didClose: () => {
                if (this.resetFormValue) {
                    const form = document.querySelector("#party_message_form")
                    if (form) form.reset()
                    // Also clear Quill editor if present
                    if (window.__quillById && window.__quillById["editor_send_message"]) {
                        window.__quillById["editor_send_message"].setContents([])
                    }
                }
            }
        })

        // remove the trigger node
        this.element.remove()
    }
}